import React from 'react';

import Hero from 'Site/Ui/Hero';
import ContentController from 'RLX/Controllers/ContentController';

class HeroEditor extends ContentController {
  constructor (props) {
    super(props);
  }

  static getInitialShape () {
    return {
      fullWidth: true,
      props: {
        title: '',
        background: {
          position: '',
          image: ''
        },
        buttons: []
      }
    };
  }

  getClassName () {
    return 'HeroEditor';
  }

  getPreview () {
    const { props } = this.props.content;
    return (
      <Hero {...props} />
    );
  }

  getFields () {
    const { content } = this.props;
    return [
      [
        {
          type: 'textarea',
          icon: 'header',
          label: <span>Hero Text <span style={{opacity:0.4}}>(Line-breaks are preserved)</span></span>,
          value: content.props.title,
          rows: 3,
          onChange: this.applyUpdate((title, existing) => {
            const { props } = existing;
            return { ...existing, props: { ...props, title } };
          })
        },
        {
          type: 'buttonSet',
          icon: 'ellipsis-h',
          className: 'stack',
          label: <span>Hero Buttons <span style={{opacity:0.3}}>(Optional)</span></span>,
          value: content.props.buttons,
          onChange: this.applyUpdate((buttons, existing) => {
            const { props } = existing;
            return { ...existing, props: { ...props, buttons } };
          })
        }
      ],
      [
        {
          type: 'image',
          icon: 'image',
          label: 'Background Image URL',
          value: content.props.background.image,
          onChange: this.applyUpdate((image, existing) => {
            const { props } = existing;
            const { background } = props;
            return { ...existing, props: { ...props, background: { ...background, image } } };
          })
        },
        {
          icon: 'arrows',
          type: 'text',
          className: 'half',
          label: 'Background Position',
          value: content.props.background.position,
          onChange: this.applyUpdate((position, existing) => {
            const { props } = existing;
            const { background } = props;
            return { ...existing, props: { ...props, background: { ...background, position } }
            };
          })
        },
        {
          type: 'toggle',
          icon: 'window-maximize',
          className: 'half',
          label: 'Full Page Width',
          value: content.fullWidth,
          onChange: this.applyUpdate((fullWidth, existing) => {
            return { ...existing, fullWidth };
          })
        }
      ]
    ];
  };
};

export default HeroEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/HeroEditor.jsx